import { Component, OnInit } from '@angular/core';
import { OrganisationInteractionService } from '../../../services';
import { IOrganisationInteraction } from '../../../interfaces/interactions/organisation-interaction';
import { LazyLoadEvent, MessageService } from 'primeng';
import { IPageResult } from '../../../interfaces/page-result';
import { IInteractionFilter } from '../../../interfaces/interactions/interaction-filter';

@Component({
  selector: 'interactions-report',
  styleUrls: ['./interactions-report.component.scss'],
  templateUrl: './interactions-report.component.html',
})
export class InteractionsReportComponent implements OnInit {
  constructor(
    private interactionsService: OrganisationInteractionService,
    private messageService: MessageService,
  ) {}

  public page: IPageResult<IOrganisationInteraction> = {
    items: [],
    total: 0,
  };

  loading = true;
  interactions: IOrganisationInteraction[] = [];

  ngOnInit() {
    const filter = this.getDefaultFilter();
    this.load(filter);
  }

  getDefaultFilter() {
    return <IInteractionFilter>{
      first: 0,
      rows: 25,
      sortField: 'addedDate',
      sortOrder: 1,
      filters: {
        organisationId: {},
      },
    };
  }

  load(filterCommand: IInteractionFilter) {
    this.loading = true;
    this.interactionsService
      .getInteractionsReport(filterCommand)
      .then((result) => {
        this.page.items = result.items;
        this.page.total = result.total;

        this.page.items.forEach((item) => {
          const wl = this.interactionsService.getWarningLevel(item.addedDate);
          item.warningLevel = wl;
        });

        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Loading Interactions Report',
          detail: `${err}`,
        });
      });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    let filter = this.getDefaultFilter();
    filter.first = event.first;
    filter.rows = event.rows;
    if (event.sortField) filter.sortField = event.sortField;
    filter.sortOrder = event.sortOrder;

    this.load(filter);
  }
}
